'use client';
import { useEffect } from 'react';

export function useGoogleTagManager({ gtmId }: { gtmId: string }) {
  /*
  n.b: We want Gtag to be loaded in the browser and not strictly as part of the React/NestJS App.
  It needs to exist outside so it can load and send events agnostically to google.

  https://support.google.com/tagmanager/answer/14847097?hl=en&sjid=16533891934344585724-NC
  */

  useEffect(() => {
    // @ts-expect-error window.dataLayer is created upon script load
    if (window.dataLayer) {
      // dataLayer is already defined, so GTM is already loaded
      return;
    }
    const gtmScript = (function (w, d, s, l, i) {
      // GTM script as written in Google Tag Manager, excuse the abbreviation.
      w[l] = w[l] || [];
      w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
      let f = d.getElementsByTagName(s)[0],
        j = d.createElement(s) as HTMLScriptElement,
        dl = l != 'dataLayer' ? '&l=' + l : '';
      j.async = true;
      j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
      f.parentNode?.insertBefore(j, f);
      return j;
    })(window, document, 'script', 'dataLayer', gtmId);

    return () => {
      document.head.removeChild(gtmScript);
    };
  }, [gtmId]);
}
